const removeMultipleSpaces = (value) => {
  if (value === undefined) return undefined
  if (!value) return ""
  const splittedValue = value.split(" ")
  return splittedValue.reduce((acc, curr) => `${acc} ${curr}`.trim(), "")
}

export default removeMultipleSpaces
